export default {
  bigStat: [
    {
      product: 'Light Blue',
      total: '4,232',
      color: 'primary',
      registrations: {
        value: 830,
        profit: true,
      },
      bounce: {
        value: 4.5,
        profit: false,
      },
    },
    {
      product: 'Sing App',
      total: '754',
      color: 'danger',
      registrations: {
        value: 30,
        profit: true,
      },
      bounce: {
        value: 2.5,
        profit: true,
      },
    },
    {
      product: 'RNS',
      total: '1,025',
      color: 'info',
      registrations: {
        value: 230,
        profit: true,
      },
      bounce: {
        value: 21.5,
        profit: false,
      },
    },
  ],
  table: [
    {
      id: 0,
      name: 'Abdul Karim',
      email: 'karim@wxample.com',
      phone: '01712344321',
      payment: '3000 tk',
      date: '11 May 2017',
      city: 'Dhaka',
      status: 'Add',
      workStatus: false,
    },
    {
      id: 1,
      name: 'Rahim Hasan',
      email: 'rahimhasan@wxample.com',
      phone: '01823455432',
      payment: '3000 tk',
      date: '4 Jun 2017',
      city: 'Khulna',
      status: 'Add',
      workStatus: false,
    },
    {
      id: 2,
      name: 'Karim Hossain',
      email: 'karimhossain@wxample.com',
      phone: '01934566543',
      payment: '3000 tk',
      date: '27 Aug 2017',
      city: 'Bogra',
      status: 'Remove',
      workStatus: true,
    },
    {
      id: 3,
      name: 'Abdur Rahman',
      email: 'abdurrahmon@wxample.com',
      phone: '01545677654',
      payment: '3000 tk',
      date: '19 Feb 2018',
      city: 'Rajshahi',
      status: 'Add',
      workStatus: false,
    },
    {
      id: 4,
      name: 'Farhan Ahmed',
      email: 'farhanahmed@wxample.com',
      phone: '01345688765',
      payment: '3000 tk',
      date: '1 Mar 2018',
      city: 'Sylhet',
      status: 'Remove',
      workStatus: true,
    },
  ],
};
